import { Landmark } from "lucide-react";

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="min-h-screen grid lg:grid-cols-2 bg-[var(--bg)]">
    <div className="hidden lg:flex flex-col justify-between p-12 bg-[#0F172A] text-white grid-bg">
      <div className="flex items-center gap-2 font-head text-2xl font-bold tracking-tight">
        <Landmark className="w-6 h-6 text-sky-400" /> LEDGERLINE
      </div>
      <div>
        <h1 className="font-head text-6xl font-bold leading-[0.95] tracking-tight">
          Group-wise<br />settlements,<br /><span className="text-sky-400">date by date.</span>
        </h1>
        <p className="mt-6 text-slate-400 max-w-md">Record site name, user ID and settlement amount under each group. Totals, search and Excel export built in.</p>
      </div>
      <p className="text-xs text-slate-500 font-mono">₹ INR · CSV · XLSX</p>
    </div>
    <div className="flex items-center justify-center p-6">
      <div className="w-full max-w-sm space-y-6 fade-up">
        <div>
          <h2 className="font-head text-4xl font-bold tracking-tight">{title}</h2>
          <p className="text-sm text-slate-500 mt-1">{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
  </div>
);
